import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Sidebar from "./Sidebar";
import SearchWord from "./SearchWord";
import VocabularyList from "./VocabularyList";
import LearningBoard from "./LearningBoard";
import TranslateText from "./TranslateText";
import Header from "./Header";
import Marklive from './Marklive';
import CompareWords from './CompareWords';
import VocabularyReview from './VocabularyReview';
import Homepage from './Homepage';
import "./styles/tailwind.css";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="/search-word" element={
          <div style={{ display: "flex" }}>
            <Header />
            <Sidebar />
            <main style={{ flex: 1 }}>
              <SearchWord />
            </main>
          </div>
        } />
        <Route path="/vocabulary-list" element={
          <div style={{ display: "flex" }}>
            <Header />
            <Sidebar />
            <main style={{ flex: 1 }}>
              <VocabularyList />
            </main>
          </div>
        } />
        <Route path="/learning-board" element={
          <div style={{ display: "flex" }}>
            <Header />
            <Sidebar />
            <main style={{ flex: 1 }}>
              <LearningBoard />
            </main>
          </div>
        } />
        <Route path="/translate-text" element={
          <div style={{ display: "flex" }}>
            <Header />
            <Sidebar />
            <main style={{ flex: 1 }}>
              <TranslateText />
            </main>
          </div>
        } />
        <Route path="/marklive" element={
          <div style={{ display: "flex" }}>
            <Header />
            <Sidebar />
            <main style={{ flex: 1 }}>
              <Marklive />
            </main>
          </div>
        } />
        <Route path="/compare-words" element={
          <div style={{ display: "flex" }}>
            <Header />
            <Sidebar />
            <main style={{ flex: 1 }}>
              <CompareWords />
            </main>
          </div>
        } />
        <Route path="/vocabulary-review" element={
          <div style={{ display: "flex" }}>
            <Header />
            <Sidebar />
            <main style={{ flex: 1 }}>
              <VocabularyReview />
            </main>
          </div>
        } />
      </Routes>
    </Router>
  );
}

export default App;
